import React from 'react';
import Modal from './Modal';

interface KeyboardShortcutsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const KeyboardShortcutsModal: React.FC<KeyboardShortcutsModalProps> = ({ isOpen, onClose }) => {
  const shortcuts = [
    { key: 'K', ctrl: true, description: 'Focus search input' },
    { key: '/', ctrl: true, description: 'Show keyboard shortcuts' },
    { key: 'Escape', description: 'Close modals/sidebar' },
  ];

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onClose}
      title="Keyboard Shortcuts"
      message={
        <div className="space-y-3">
          {shortcuts.map((shortcut, index) => (
            <div key={index} className="flex items-center justify-between p-2 rounded-lg hover:bg-gray-50">
              <span className="text-gray-700">{shortcut.description}</span>
              <kbd className="px-2 py-1 bg-gray-100 border border-gray-300 rounded text-sm font-mono">
                {shortcut.ctrl && (navigator.platform.includes('Mac') ? '⌘' : 'Ctrl')} {shortcut.key}
              </kbd>
            </div>
          ))}
        </div>
      }
      type="info"
      confirmText="Got it"
    />
  );
};

export default KeyboardShortcutsModal;

